import { imagesWEBP } from "./webpImages";
export const oemPriceList = {
  osm: [
    {
      model: "OSM Rage+ 8.5 kWh",
      prices: "Starting From ₹ 3.6 - 4.1 lakhs",
      description:
        "OSM Rage+ 8.5 kWh is an electric three-wheeler with a top speed of 45 km/h and a range of up to 100 km. It is a cargo vehicle with a payload capacity of 500 kg and is available in multiple colours.",
      image: imagesWEBP?.osm?.osmVehicle1,
    },
    {
      model: "OSM Rage+ 10.8 kWh",
      prices: "Starting From ₹ 3.9 - 4.4 lakhs",
      description:
        "It is an upgraded version of OSM Rage+ 8.5 kWh with a top speed of 45 km/h and a range of up to 120 km.It is a cargo vehicle with a payload capacity of more than 500 kg. It is powered by a 10.8 kWh battery and takes 3-4 hours to fully charge.",
      image: imagesWEBP?.osm?.osmVehicle2,
    },
    {
      model: "OSM Rage+ Frost",
      prices: "Starting From ₹ 8.41 lakhs",
      description:
        "It is an electric three-wheeler cargo vehicle that is perfect for commercial use. It has a range of up to 80 kilometres on a single charge and can carry a load of up to 400 kilograms. It also features a refrigerated carriage that can maintain a temperature of 0 degrees Celsius.",

      image: imagesWEBP?.osm?.osmVehicle3,
    },

    {
      model: "OSM Rage+  Hydraulic Tipper",
      prices: "Starting From 4.5 - 5.25 lakhs",
      description:
        "OSM Rage+ Tipper is an electric three-wheeler garbage collection vehicle with a payload capacity of 500 kg. It has a hydraulic tipping system that allows for easy and efficient loading and unloading of garbage.      ",
      image: imagesWEBP?.osm?.osmVehicle1,
    },

    {
      model: "OSM Rage+ Rapid",
      prices: "Starting From 5.6 lakhs",
      description:
        "The OSM EV Auto is a three-wheeler vehicle that is perfect for last-mile delivery and transportation. It has a range of up to 100 kilometres on a single charge and can be charged just in 35 mins.      ",
      image: imagesWEBP?.osm?.osmVehicle2,
    },
  ],

  mahindra: [
    {
      model: "Mahindra Treo Zor",
      prices: "₹ 3.4 - 3.9 lakhs",
      description:
        "A compact and efficient electric auto designed for urban mobility. With its small footprint, it's perfect for navigating busy streets. Offering sustainable transportation, it provides an eco-friendly solution for short-distance travel and last-mile delivery needs.",
      image: imagesWEBP?.Mahindra?.mahindraVehicle1,
    },
    {
      model: "Mahindra Zor Grand",
      prices: "₹ 3.9 - 4.4 lakhs",
      description:
        "This mahindra electric mini truck is designed to meet the demands of commercial goods transportation. With its spacious interior and robust build, it offers ample storage capacity and durability. Combining efficiency and reliability, it provides a sustainable and cost-effective solution for businesses.  ",
      image: imagesWEBP?.Mahindra?.mahindraVehicle2,
    },
    {
      model: "Mahindra Treo Plus",
      prices: "₹ 3.8 - 3.9 lakhs",
      description:
        "This mahindra electric mini truck is designed to meet the demands of commercial goods transportation. With its spacious interior and robust build, it offers ample storage capacity and durability. Combining efficiency and reliability, it provides a sustainable and cost-effective solution for businesses.  ",
      image: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle1,
    },
  ],
  piaggio: [
    {
      model: "Piaggio Ape E-Xtra FX",
      prices: "₹ 3.6 - 4.2 lakhs",
      description:
        "An upgraded version of the Ape E-Xtra offering improved specifications and features for efficient cargo transportation.",
      image: imagesWEBP?.piaggio?.piaggioVehicle1,
    },
    {
      model: "Piaggio Ape E-Xtra FX Max",
      prices: "₹ 3.9 - 4.3 lakhs",
      description:
        "A variant of the Ape E-Xtra FX, providing enhanced features and specifications for maximum load-carrying capacity.",
      image: imagesWEBP?.piaggio?.piaggioVehicle2,
    },
    {
      model: "Piaggio E-City Fx",
      prices: "₹ 3.2 - 3.3 lakhs",
      description:
        "A variant of the Piaggio E-City Fx, providing enhanced features and specifications for passenger transportation",
      image: imagesWEBP?.vehicleBenefitsPiaggioEcityFx0,
    },
  ],

  etrio: [
    {
      model: "E-trio Touro Max++",
      prices: "₹ 3.9 - 4.4 lakhs",
      image: imagesWEBP?.Etrio?.etrioVehicle1,
      description:
        "This is an electric three-wheeler vehicle that is perfect for commercial transportation. It has a range of up to 157 kilometers on a single charge.      ",
    },
  ],

  euler: [
    {
      model: "Euler HiLoad DV",
      prices: "Starting from ₹4.46 lakhs",
      image: imagesWEBP?.Euler?.eulerVehicle1,
      description:
        "This is an electric three-wheeler vehicle that is perfect for commercial transportation. It has a payload capacity of up to 688 kg and a range of up to 125 km. It comes with halogen headlamps for better visibility and a 30mm ground clearance for water wading.",
    },
    {
      model: "Euler HiLoad PV",
      prices: "Starting from ₹4.26 lakhs",
      image: imagesWEBP?.Euler?.eulerVehicle2,
      description:
        "This is an electric three-wheeler vehicle that is perfect for commercial transportation. It has a payload capacity of up to 727 kg and a range of up to 125 km. It comes with an onboard charger and front disc brakes for unmatched safety.",
    },
  ],
  eulerHindi: [
    {
      model: "Euler HiLoad DV",
      prices: "Starting from ₹4.46 lakhs",
      image: imagesWEBP?.Euler?.eulerVehicle1,
      description:
        "यह एक इलेक्ट्रिक 3-व्हीलर गाड़ी है जो कमर्शियल ट्रांसपोर्टेशन के लिए एकदम सही है। इसकी पेलोड कैपेसिटी 688 किलोग्राम तक है और इसकी रेंज 125 किमी तक है। यह बेहतर विसिबिलिटी के लिए हैलोजन हेडलैम्प और पानी में चलने के लिए 30mm ग्राउंड क्लीयरेंस के साथ आता है।",
    },
    {
      model: "Euler HiLoad PV",
      prices: "Starting from ₹4.26 lakhs",
      image: imagesWEBP?.Euler?.eulerVehicle2,
      description:
        "यह एक इलेक्ट्रिक 3-व्हीलर गाड़ी है जो कमर्शियल ट्रांसपोर्टेशन के लिए एकदम सही है। इसकी पेलोड कैपेसिटी 727 किलोग्राम तक है और इसकी रेंज 125 किमी तक है। यह बेजोड़ सुरक्षा के लिए ऑनबोर्ड चार्जर और फ्रंट डिस्क ब्रेक के साथ आता है।",
    },
  ],
  altigreen: [
    {
      model: "Altigreen neEV      ",
      prices: "Starting from 4.26 lakhs ",
      image: imagesWEBP?.AltiGreen?.altigreenVehicle,
      description:
        "neEV from Altigreen, an innovation in electric cargo vehicles. With advanced technology and a certified range of 150 km, neEV offers efficient performance for last-mile delivery. Its regenerative braking and low operational cost of 0.92 paise per km make it an ideal choice for sustainable businesses.",
    },
    {
      model: "Altigreen neEV Tez",
      prices: "Starting from 4.34 lakhs  ",
      image: imagesWEBP?.AltiGreen?.altigreenVehicle,
      description:
        "neEV Tez by Altigreen brings rapid charging to electric cargo vehicles. Charging in under 15 minutes, Tez maintains neEV's 150 km range and exceptional features. It's a game-changer for quick and efficient deliveries, showcasing Altigreen's commitment to innovation and sustainability.",
    },
  ],
  greaves: [
    {
      model: "Greaves Eltra",
      prices: "Starting from 3.99 lakhs ",
      image: imagesWEBP?.greaves?.greavesVehicle1,
      description:
        "The Greaves Eltra is an innovative electric vehicle designed for efficient and eco-friendly mobility. With advanced technology and impressive performance, it's an ideal choice for those seeking sustainable transportation solutions.",
    },
    {
      model: "Greaves Epro",
      prices: "Starting from 3.08 lakhs ",
      image: imagesWEBP?.greaves?.greavesVehicle2,
      description:
        "The Greaves Epro takes electric mobility to the next level with its eco-conscious design and efficient performance. With quick charging capabilities and advanced features, it's perfect for those who value sustainability without compromising on convenience.",
    },
  ],
};
export const oemPriceListHindi = {
  mahindra: [
    {
      model: "महिंद्रा ट्रियो ज़ॉर",
      prices: "₹ 3.4 - 3.9 lakhs",
      description:
        "यह छोटी सी दिखने वाली इलेक्ट्रिक गाड़ी वास्तव मे ज़ोरदार इलेक्ट्रिक ऑटो हैं, जो शहर मे परिवहन के लिए डिज़ाइन किया गया हैं। इसकी छोटी बनावट, व्यस्त सड़कों  पर पूरी तरह से उपयुक्त हैं। प्रदुषण मुक्त  परिवहन के साथ, यह कम दूरी और ई-कॉमर्स डिलीवरी की आवश्यकताओं  के लिए एक अतुलनीय बिकल्प हैं। ",
      image: imagesWEBP?.Mahindra?.mahindraVehicle1,
    },
    {
      model: "महिंद्रा ज़ॉर ग्रैड",
      prices: "₹ 3.9 - 4.4 lakhs",
      description:
        "यह महिंद्रा इलेक्ट्रिक टेम्पो सामान परिवहन के लिए डिज़ाइन किया गया हैंं । अपने पर्याप्त जगह वाले इंटीरियर और टिकाऊ बनावट के साथ, यह बेहतर लोड क्षमता और मजबूती प्रदान करता हैं। यह व्यवसायो के लिए एक सठीक और किफायती समाधान हैं, जिसपर आप भरोसा कर सकते हैं। ",
      image: imagesWEBP?.Mahindra?.mahindraVehicle2,
    },
  ],
};
export const oemPriceListKannada = {
  mahindra: [
    {
      model: "ಮಹೀಂದ್ರ ಟ್ರಿಯೋ ಜೋರ್",
      prices: "₹ 3.4 - 3.9 lakhs",
      description:
        "ನ್ಯಾಸಗೊಳಿಸಲಾದ ಕಾಂಪ್ಯಾಕ್ಟ್ ಮತ್ತು ಪರಿಣಾಮಕಾರಿ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋ. ಅದರ ಸಣ್ಣ ಹೆಜ್ಜೆಗುರುತನ್ನು ಹೊಂದಿರುವ, ಬಿಡುವಿಲ್ಲದ ಬೀದಿಗಳಲ್ಲಿ ನ್ಯಾವಿಗೇಟ್ ಮಾಡಲು ಇದು ಪರಿಪೂರ್ಣವಾಗಿದೆ. ಸುಸ್ಥಿರ ಸಾರಿಗೆಯನ್ನು ನೀಡುತ್ತಿದೆ, ಇದು ಕಡಿಮೆ-ದೂರ ಪ್ರಯಾಣ ಮತ್ತು ಕೊನೆಯ-ಮೈಲಿ ವಿತರಣಾ ಅಗತ್ಯಗಳಿಗಾಗಿ ಪರಿಸರ ಸ್ನೇಹಿ ಪರಿಹಾರವನ್ನು ಒದಗಿಸುತ್ತದೆ.",
      image: imagesWEBP?.Mahindra?.mahindraVehicle1,
    },
    {
      model: "ಮಹೀಂದ್ರ ಟ್ರಿಯೋ ಜೋರ್",
      prices: "₹ 3.9 - 4.4 lakhs",
      description:
        "ನಗರ ಚಲನಶೀಲತೆಗಾಗಿ ವಿನ್ಯಾಸಗೊಳಿಸಲಾದ ಕಾಂಪ್ಯಾಕ್ಟ್ ಮತ್ತು ಪರಿಣಾಮಕಾರಿ ಎಲೆಕ್ಟ್ರಿಕ್ ಆಟೋ. ಅದರ ವಿಶಿಷ್ಟ ವಿನ್ಯಾಸದೊಂದಿಗೆ, ಬಿಡುವಿಲ್ಲದ ಬೀದಿಗಳಲ್ಲಿ ನ್ಯಾವಿಗೇಟ್ ಮಾಡಲು ಇದು ಪರಿಪೂರ್ಣವಾಗಿದೆ. ಸುಸ್ಥಿರ ಸಾರಿಗೆಯನ್ನು ನೀಡುತ್ತಿದೆ, ಇದು ಕಡಿಮೆ ದೂರದ ಪ್ರಯಾಣ ಮತ್ತು ಕೊನೆಯ-ಮೈಲಿ ವಿತರಣಾ ಅಗತ್ಯಗಳಿಗಾಗಿ ಪರಿಸರ ಸ್ನೇಹಿ ಪರಿಹಾರವನ್ನು ಒದಗಿಸುತ್ತದೆ.",
      image: imagesWEBP?.Mahindra?.mahindraVehicle2,
    },
  ],
};
